export const reducersActions = {
    GET_USERS: "GET_USERS",
    GET_USERS_REQUEST: "GET_USERS_REQUEST",
    GET_USERS_ERROR: "GET_USERS_ERROR",

    FETCH_CAMPAIGNS_REQUEST: "FETCH_CAMPAIGNS_REQUEST",
    FETCH_CAMPAIGNS_SUCCESS: "FETCH_CAMPAIGNS_SUCCESS",
    FETCH_CAMPAIGNS_FAILURE: "FETCH_CAMPAIGNS_FAILURE",

    FETCH_COLLECTIONS_REQUEST: "FETCH_COLLECTIONS_REQUEST",
    FETCH_COLLECTIONS_SUCCESS: "FETCH_COLLECTIONS_SUCCESS",
    FETCH_COLLECTIONS_FAILURE: "FETCH_COLLECTIONS_FAILURE",

    FETCH_CAMPAIGN_REQUEST: "FETCH_CAMPAIGN_REQUEST",
    FETCH_CAMPAIGN_SUCCESS: "FETCH_CAMPAIGN_SUCCESS",
    FETCH_CAMPAIGN_FAILURE: "FETCH_CAMPAIGN_FAILURE",

    GET_COLLECTIONS_REQUEST: "GET_COLLECTIONS_REQUEST",
    GET_COLLECTIONS_SUCCESS: "GET_COLLECTIONS_SUCCESS",
    GET_COLLECTIONS_FAILURE: "GET_COLLECTIONS_FAILURE",

    GET_BATCHES_REQUEST: "GET_BATCHES_REQUEST",
    GET_BATCHES_SUCCESS: "GET_BATCHES_SUCCESS",
    GET_BATCHES_FAILURE: "GET_BATCHES_FAILURE",

    SET_START_DATE: 'SET_START_DATE',
    SET_END_DATE: 'SET_END_DATE',
    CLEAR_DATE_RANGE: 'CLEAR_DATE_RANGE',


    FETCH_BRANDS_REQUEST: "FETCH_BRANDS_REQUEST",
    FETCH_BRANDS_SUCCESS: "FETCH_BRANDS_SUCCESS",
    FETCH_BRANDS_FAILURE: "FETCH_BRANDS_FAILURE",


    FETCH_TAGS_REQUEST: "FETCH_TAGS_REQUEST",
    FETCH_TAGS_SUCCESS: "FETCH_TAGS_SUCCESS",
    FETCH_TAGS_FAILURE: "FETCH_TAGS_FAILURE",
};
